/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBindWallet.vue?vue&type=template&id=7c7b88cf&scoped=true"
import script from "./popBindWallet.vue?vue&type=script&lang=js"
export * from "./popBindWallet.vue?vue&type=script&lang=js"
import style0 from "./popBindWallet.vue?vue&type=style&index=0&id=7c7b88cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7b88cf",
  null
  
)

export default component.exports